import axios from "axios";
import notification from "ant-design-vue/es/notification";
import { VueAxios } from "./axios";
// 创建 axios 实例
axios.defaults.withCredentials = true;
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 6000000 // 请求超时时间
});

const err = error => {
  if (error.response) {
    const data = error.response.data;
    if (error.response.status === 403) {
      notification.error({
        message: "Forbidden",
        description: data.message
      });
    }
    if (
      error.response.status === 401 &&
      !(data.result && data.result.isLogin)
    ) {
      notification.error({
        message: "Unauthorized",
        description: "Authorization verification failed"
      });
    }
  }
  return Promise.reject(error);
};

// response interceptor
service.interceptors.response.use(response => {
  if (response.data.Code === 22) {
    notification.error({
      message: "错误提示",
      description: response.data.Message
    });
    return;
  }
  return response.data;
}, err);

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service);
  }
};

export { installer as VueAxios, service as axios };
